import Component from '../core/Component'

export default class FilterOpener extends Component {
    constructor(element, options = {}) {
        super(element, options)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const id = event.target.href.split('#')[1]
        if (!id) {
            return
        }

        const filter = Component.getFromElement(id)
        if (!filter) {
            return
        }

        filter.open()
        event.preventDefault()
    }
}